import { useMemo } from 'react';
import { useSearchParams } from 'react-router-dom';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';
import { Tabs, TabsContent, TabsList, TabsTrigger } from '@/components/ui/tabs';
import { LogInWithEmailForm } from './login-form';
import { CreateAccountWithEmailForm } from './create-account-form';
import { GoogleSignInButton } from './google-sign-in-button';

export function LoginPageContent() {
    const [searchParams] = useSearchParams();
    const defaultTab = useMemo(() => searchParams.get('tab') || 'login', [searchParams]);

    return (
        <div className="flex min-h-screen flex-col items-center justify-center bg-background p-4">
        <Card className="w-full max-w-md">
            <CardHeader className="text-center">
            <CardTitle className="text-2xl">Welcome</CardTitle>
            <CardDescription>Log in or create an account to manage your adventures.</CardDescription>
            </CardHeader>
            <CardContent>
            <Tabs defaultValue={defaultTab} className="w-full">
                <TabsList className="grid w-full grid-cols-2">
                <TabsTrigger value="login">Log In</TabsTrigger>
                <TabsTrigger value="signup">Sign Up</TabsTrigger>
                </TabsList>
                <TabsContent value="login">
                <div className="space-y-4 pt-4">
                    <GoogleSignInButton />
                    <div className="relative">
                    <div className="absolute inset-0 flex items-center">
                        <span className="w-full border-t" />
                    </div>
                    <div className="relative flex justify-center text-xs uppercase">
                        <span className="bg-background px-2 text-muted-foreground">Or continue with</span>
                    </div>
                    </div>
                    <LogInWithEmailForm />
                </div>
                </TabsContent>
                <TabsContent value="signup">
                <div className="space-y-4 pt-4">
                    <GoogleSignInButton />
                    <div className="relative">
                    <div className="absolute inset-0 flex items-center">
                        <span className="w-full border-t" />
                    </div>
                    <div className="relative flex justify-center text-xs uppercase">
                        <span className="bg-background px-2 text-muted-foreground">Or continue with</span>
                    </div>
                    </div>
                    <CreateAccountWithEmailForm />
                </div>
                </TabsContent>
            </Tabs>
            </CardContent>
        </Card>
        </div>
    )
}
